import React from 'react';
import { useTranslation } from 'react-i18next';
import './RefundPolicy.css';
import Footer2 from '../footer';

const RefundPolicy = () => {
  const { t } = useTranslation();
  
  return (
    <div className="refund-policy">
      <div className="policy-header">
        <div className="header-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
          <div className="decoration-circle circle-3"></div>
        </div>
        <h1 className="policy-title">{t('refund.title')}</h1>
        <p className="last-updated">{t('refund.lastUpdated')}</p>
        <div className="header-line"></div>
      </div>

      <div className="policy-intro">
        <p className="intro-text">{t('refund.intro')}</p>
      </div>

      <div className="policy-content">
        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">01</span>
            <h2>{t('refund.section1.title')}</h2>
          </div>
          <p>{t('refund.section1.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">02</span>
            <h2>{t('refund.section2.title')}</h2>
          </div>
          <p>{t('refund.section2.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">03</span>
            <h2>{t('refund.section3.title')}</h2>
          </div>
          <p>{t('refund.section3.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">04</span>
            <h2>{t('refund.section4.title')}</h2>
          </div>
          <p>{t('refund.section4.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">05</span>
            <h2>{t('refund.section5.title')}</h2>
          </div>
          <p>{t('refund.section5.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">06</span>
            <h2>{t('refund.section6.title')}</h2>
          </div>
          <p>{t('refund.section6.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">07</span>
            <h2>{t('refund.section7.title')}</h2>
          </div>
          <p>{t('refund.section7.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">08</span>
            <h2>{t('refund.section8.title')}</h2>
          </div>
          <p>{t('refund.section8.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">09</span>
            <h2>{t('refund.section9.title')}</h2>
          </div>
          <p>{t('refund.section9.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">10</span>
            <h2>{t('refund.section10.title')}</h2>
          </div>
          <p>{t('refund.section10.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">11</span>
            <h2>{t('refund.section11.title')}</h2>
          </div>
          <p>{t('refund.section11.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">12</span>
            <h2>{t('refund.section12.title')}</h2>
          </div>
          <p>{t('refund.section12.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">13</span>
            <h2>{t('refund.section13.title')}</h2>
          </div>
          <p>{t('refund.section13.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">14</span>
            <h2>{t('refund.section14.title')}</h2>
          </div>
          <p>{t('refund.section14.content')}</p>
        </section>

        <section className="policy-section">
          <div className="section-header">
            <span className="section-number">15</span>
            <h2>{t('refund.section15.title')}</h2>
          </div>
          <p>{t('refund.section15.content')}</p>
        </section>
      </div>

      <div className="refund-process">
        <h3 className="process-title">{t('refund.process.title')}</h3>
        <div className="process-steps">
          <div className="process-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h4>{t('refund.process.step1.title')}</h4>
              <p>{t('refund.process.step1.content')}</p>
            </div>
          </div>
          <div className="step-connector"></div>
          <div className="process-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h4>{t('refund.process.step2.title')}</h4>
              <p>{t('refund.process.step2.content')}</p>
            </div>
          </div>
          <div className="step-connector"></div>
          <div className="process-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h4>{t('refund.process.step3.title')}</h4>
              <p>{t('refund.process.step3.content')}</p>
            </div>
          </div>
          <div className="step-connector"></div>
          <div className="process-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h4>{t('refund.process.step4.title')}</h4>
              <p>{t('refund.process.step4.content')}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="non-refundable">
        <h3 className="non-refundable-title">{t('refund.nonRefundable.title')}</h3>
        <div className="non-refundable-list">
          <div className="non-refundable-item">
            <span className="warning-icon">⚠️</span>
            <span>{t('refund.nonRefundable.item1')}</span>
          </div>
          <div className="non-refundable-item">
            <span className="warning-icon">⚠️</span>
            <span>{t('refund.nonRefundable.item2')}</span>
          </div>
          <div className="non-refundable-item">
            <span className="warning-icon">⚠️</span>
            <span>{t('refund.nonRefundable.item3')}</span>
          </div>
          <div className="non-refundable-item">
            <span className="warning-icon">⚠️</span>
            <span>{t('refund.nonRefundable.item4')}</span>
          </div>
          <div className="non-refundable-item">
            <span className="warning-icon">⚠️</span>
            <span>{t('refund.nonRefundable.item5')}</span>
          </div>
        </div>
      </div>

      <div className="policy-footer mb-5">
        <div className="footer-line"></div>
        <p className="footer-text">{t('refund.footer')}</p>
        <div className="contact-info mb-5">
          <p>{t('refund.contact.email')}</p>
          <p>{t('refund.contact.responseTime')}</p>
        </div>
      </div>

      <Footer2 style={{ textAlign: 'center' }}>
              </Footer2>
    </div>
  );
};

export default RefundPolicy;